/*
 * File: product-details.component.ts                                          *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 27th January 2022 23:46:22                          *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */



import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Catalog, Category, Product } from '@nousmedis/cc-types';
import { ProductService } from 'app/modules/catalog-cloud/services/product.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit, OnDestroy {
  item: Product;
  productObservable: Subscription;
  @Input() catalog: Catalog;
  category: Category;
  constructor (private productService: ProductService) {

  }

  ngOnDestroy(): void {
    this.productObservable.unsubscribe();
  }

  ngOnInit(): void {
    this.productObservable = this.productService.productDetails$.subscribe((product: Product) => {
      this.item = product;
      if (this.catalog && this.catalog.categories) {
        this.category = this.catalog.categories.find((cat: Category) => {
          return cat.id === product.idCategory;
        });
      }
      

    });
  }

  // hide(){
  //   let details = document.getElementById('product-details-' + this.item.id);
  //   details.classList.add('item-details-hide');
  //    this.hideMe.emit();
  // }

}
